export default "__VITE_ASSET__DbQnAtfa__"